import React from 'react';
import './Sections.scss';

function Section3() {
  return (
    <section className="sections sections-marginBox">
      <h2 className="sections-title">Support in a storm</h2>
      <p className="sections-copy">
        Not too long ago, most Americans thought little of hopping on a flight for a cross-country
        trip to attend a big family gathering or a long weekend with friends. The pandemic has
        scrambled those calculations, making travel more nerve wracking and pushing both buyers and
        sellers to reconsider the value of having a support system close at hand. As a result, NAR’s{' '}
        <a
          className="hyperLink"
          href=" https://cdn.nar.realtor/sites/default/files/documents/2022-highlights-from-the-profile-of-home-buyers-and-sellers-report-11-03-2022_0.pdf"
          target="_blank"
          rel="sponsored"
        >
          2022 Profile of Home Buyers and Sellers
        </a>{' '}
        shows that the desire to be closer to friends and family is the number one motivating factor
        for both sellers and repeat home buyers.
      </p>
      <div className="quote">
        <div className="quote__contents">
          <div className="quotationMark">“</div>
          <blockquote className="quote__copy">
            Even pre-pandemic, we saw that people were moving to be near friends and family, but the
            pandemic really pressed the fast-forward button on accelerating that trend."
          </blockquote>
          <div className="quote__caption">
            Dr. Jessica Lautz,{' '}
            <span className="italic">
              Deputy Chief Economist and Vice President of Research at NAR
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section3;
